const _wrapInArray = (value) => {
    if(!Array.isArray(value)) {
        return [value]
    }

    return value
};

export default {
    props: {
        item: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },

    data() {
        return {
            errors: {},
            submitting: false,
            copy: {}
        }
    },

    created() {
        // this.$set(this, 'copy', _.merge({}, this.copy, this.item))
        this.copy = _.merge({}, this.copy, this.item)
    },

    methods: {
        setErrors(errors) {
            if (_.isObject(errors)) {
                this.errors = errors
            } else {
                this.errors = {
                    error: ['Unexpected error occurred']
                }
            }
        },

        resetErrors() {
            this.errors = {}
        },

        getError(name, defaultMessage = '') {
            if (_.has(this.errors, name)) {
                if (defaultMessage) {
                    return defaultMessage;
                }

                if (Array.isArray(_.get(this.errors, name))) {
                    return _.get(this.errors, name).join("\n")
                }
                return _.get(this.errors, name)
            }

            return undefined
        },

        getArrayError(name, index) {
            return this.getError(`${name}.${index}`)
        },

        hasError(name) {
            return !!_.has(this.errors, name)
        },

        hasArrayError(name, index) {
            return !!this.errors[`${name}.${index}`]
        },

        removeError(name) {
            if(this.hasError(name)) {
                delete this.errors[name]
            }
        },

        setError(name, error) {
            let a = this.errors
            this.errors = {}
            this.errors = _.set(a, name, error)
        },

        pushError(name, error) {
            if (this.errors[name]) {
                // this.$set(this.errors, name, [..._wrapInArray(error), ..._wrapInArray(this.errors[name])])
                this.errors.name = [..._wrapInArray(error), ..._wrapInArray(this.errors[name])]
            } else {
                // this.$set(this.errors, name, error)
                this.errors.name = error
            }
        },

        fieldType(name) {
            if (this.hasErrors) {
                return this.hasError(name) ? 'is-danger' : undefined
            }

            return undefined
        },

        wrapSubmit(func) {
            return (payload) => {
                this.submitting = true
                return func(payload)
                    .then(res => {
                        this.resetErrors()
                        return res
                    })
                    .catch((res) => {
                        this.setErrors(res.response.data.errors)
                        throw res
                    })
                    .finally(res => {
                        this.submitting = false
                        return res
                    })
            }
        }
    },

    computed: {
        hasErrors() {
            return this.errors && _.keys(this.errors).length > 0
        },

        firstError() {
            return this.errors ? _.first(_.values(this.errors)[0]) : ''
        },

        itemExists() {
            return !!this.copy.id
        }
    }
};
